import controller from './gender-group.controller'
import template from './gender-group.html'

const GenderGroupComponent = {
	bindings: {
		selectedGender: '<',
		language: '<',
		onChange: '&'
	},
	controller,
	template,
};

export default GenderGroupComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/gender-group/gender-group.component.js